<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>{{ $t("navigations.cycles") }}</h2>
      </div>
    </div>

    <!-- Filters -->
    <div class="wrapper wrapper-content">

      <!-- Table -->
    </div>
     <div class="wrapper wrapper-content">
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">{{ $t("navigations.cyclelist") }}</h5>
          <div class="d-flex">

            <div class="position-relative align-self-center"  :class="{ 'mr-3': cycleList.length != 0 }"
              aria-label="Create Cycle" tabindex="0">
              <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17" alt="Create Cycle"
                @click="CreateCycle()" />
              <div class="tool-tip">{{ $t("navigations.create cycle") }}</div>
            </div>
         
          </div>
        </div>
        <div class="ibox-content">
         
          <div class="text-center" v-if="showCycleTableLoading === true">
            <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th v-if="selectedcolumnobj['CycleId']" class="sort_block"  @click="SortCycleSelected('CycleId', 1)">
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.cycle id") }}
                       <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th v-if="selectedcolumnobj['CycleName']" class="sort_block"  @click="SortCycleSelected('CycleName', 1)"><div class="d-flex flex-row justify-content-between">
                   {{ $t("navigations.cycle name") }}
                   <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div></th>
                  <th v-if="selectedcolumnobj['ArmCode']" class="sort_block"  @click="SortCycleSelected('ArmCode', 1)"><div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.arm code") }}
                    <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th style="white-space: nowrap; width: 1%;">{{ $t('navigations.cycle duration') }} {{ $t('navigations.days') }}</th>
                  <th>{{ $t("navigations.cycle order") }}</th>
                  <th>{{ $t("navigations.cycle prefix") }}</th>
                  <th>{{ $t("navigations.min repeats") }}</th>
                  <th>{{ $t("navigations.max repeats") }}</th>
                  <th class="text-center">{{ $t("navigations.is repeatable") }}</th>
                  <th class="text-center">{{ $t("navigations.edit") }}</th>
                  <th class="text-center">{{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="item in cycleList" :key="item.id">
              <td v-if="selectedcolumnobj['CycleId']">{{item.cycleId}}</td>
              <td v-if="selectedcolumnobj['CycleName']">{{ item.cycleName }}</td>  
              <td v-if="selectedcolumnobj['ArmCode']">{{ item.armCode }}</td>  
              <!-- <td class="text-center">
                <input type="checkbox" :checked="item.isActive" onclick="return false" readonly /> 
              </td> -->
              <td>{{ item.cycleDuration }}</td>
              <td>{{ item.cycleOrder }}</td>
              <td>{{ item.cyclePrefix }}</td>
              <td>{{ item.minRepeats }}</td>
              <td>{{ item.maxRepeats }}</td>
              <td class="text-center">
                <input type="checkbox" :checked="item.isRepeatable" onclick="return false" readonly /> 
              </td> 
              <td class="text-center">
                <i class="fa fa-edit edit-delete" @click="EditCycle(item.id)" style="color: #a13b7c"></i>
              </td>
              <td class="text-center">
                <i class="fa fa-trash edit-delete" style="color: #a13b7c" @click="DeleteCycle(item.id)"></i>
              </td>
            </tr>
          </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="cycleList.length != 0" class="row mt-1 mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="
                  dataTables_paginate
                  paging_simple_numbers
                  pagination
                  float-right
                ">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPageCycle" :pages="cycleTotalPage" :range-size="1" active-color="#618bd7"
                    @update:modelValue="loadPageCycle" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<CycleModal
  v-if="showCreateCycleModal"
  :editingId="editingCycleId"
  @closeModal="closeCycleModal"
  @saved="refreshCycleList"
/>
</template>
<script src="./cycle.js"></script>